import { version } from "../package.json";

function getVersionFromLink() {
  const link = document.querySelector(
    'link[rel="stylesheet"][href*="design@"]'
  );
  if (link) {
    const match = link.href.match(/design@(\d+\.\d+\.\d+)/);
    return match ? match[1] : "unknown version";
  }

  const span = document.querySelector(".site-name");
  if (span) {
    const match = span.textContent.match(/v(\d+\.\d+\.\d+)/);
    return match ? match[1] : "unknown version";
  }

  return "unknown version";
}

function getSuffix(linkHref) {
  if (linkHref.includes("3f-design.dk")) {
    return ""; // Production
  } else if (
    process.env.NODE_ENV === "development" ||
    !linkHref.includes("3f-design.dk")
  ) {
    return "BETA"; // Beta
  }
  return "";
}

function designInfo() {
  const css =
    "color:rgb(14,66,156); background-color:rgb(234, 245, 254); font-size:100%; font-weight:bold; padding: .5em 1em; line-height:1em; border-radius: 5px; margin-inline: -4px;";

  const currentVersion =
    process.env.NODE_ENV === "development" ? version : getVersionFromLink();

  const link = document.querySelector(
    'link[rel="stylesheet"][href*="design@"]'
  );
  const suffix = link ? getSuffix(link.href) : getSuffix("");

  console.groupCollapsed("Design");
  console.info(
    "%cDesign package %s",
    css,
    `version: ${currentVersion} ${suffix}`
  );
  console.groupEnd();
}

export default {
  designInfo
};
